export const MODAL_DESELECT_WARNING_MESSAGE = 'Are you sure you want to deselect this as being proprietary information? Your "Reason Comments will be lost and cannot be reverted."'
export const MODAL_DESELECT_BUTTON_TEXT = 'Deselect Proprietary'
export const MODAL_DESELECT_TITLE = 'Deselect Proprietary Information'
export const SHOW_BUSINESS_MODAL = 'SHOW_BUSINESS_MODAL'
export const MODAL_PROPIETARY_TITLE = 'Proprietary Information'
export const MODAL_REASON_MESSAGE = 'Please provide comments on why this information cannot be provided. A representative of John Deere may be in contact with you to validate this information.'
export const UPDATE_TOTAL_MAP = 'UPDATE_TOTAL_MAP'
export const DISPLAY_PERCENTAGE_WARNING = 'DISPLAY_PERCENTAGE_WARNING'
export const LABOR_ERR_MSG = 'Error receiving Labor section, try refreshing your web browser.'
export const LABOR_SECTION_NAME_INDIRECT = 'Labor / Absenteeism'
export const LABOR_SECTION_NAME = 'Labor / Absenteeism'
export const FLEX_ERR_MSG = 'Error receiving Flexibility section, try refreshing your web browser.'
export const CYBER_ERR_MSG = 'Error receiving Cyber Security section, try refreshing your web browser.'
export const OTHER_ERR_MSG = 'Error receiving Other section, try refreshing your web browser.'
export const FLEXIBILITY_SECTION_NAME = 'Flexibility'
export const PERCENTAGE_ARRAY = [...Array(21)].map((_, i) => 5 * (i))
export const PERCENTAGE_ARRAY_FL = ['< 10','< 15','< 30','< 60','< 90','< 180','180+']
export const PERCENTAGE_CAPACITY_TITLE = "Based on Current and Forecasted demand from all Customers including John Deere units, provide the projected % Plant utilization for this location. (Plant Utilization = Actual Output / Available Capacity or Projected output / Max output)"
export const TIER_LABOR_NAME_INDIRECT = "Your Supplier Tier II";
export const TIER_LABOR_NAME = "Tier II Suppliers";
export const SAVED_SUCCESSFULLY_SURVEY = 'SAVED_SUCCESSFULLY_SURVEY';
export const ERROR_SAVING_SURVEY = 'An Error occurs while saving your respond, try again.';
export const OF_KEY = 'of'
export const USER_INFO_KEY = 'userInfo'
export const SURVEY_ANSWERS = 'surveyAnswers'
export const ADMIN_SEC_TYPE = "admin_comments"
export const ENV_PROD = "PROD"
export const SCBM_INDIRECT_SECCION_CODES = {BS:'ind_bs',LB:'ind_la',CC:'ind_cc',FL:'ind_fx',FC:'ind_fc'};
export const FUTURE_CONSIDERATIONS_SECTION_INDIRECT = 'Future Considerations';
export const CAPACITY_CONSTRAINT_SECTION_INDIRECT = 'Capacity Constraints'
export const QUESTION_PROPRIETARY = "Proprietary information, legally can't provide"
export const EMPTY_BODY = <div>
    <h5>Loading...</h5>
</div>


export const SCBM_USER_TYPE = { CONTINGENT_OFF: 'Contingent, Off-Site', CONTINGENT_ON: 'Contingent, On-Site', CONTRACTOR_OFF: 'Contractor, Off-Site', CONTRACTOR_ON: 'Contractor, On-Site', SUPPLIER: 'Supplier Employee', SALARY: 'Salary', WAGE: 'Wage' }
export const SCBM_USER_TYPE_ARR = ['Contingent, Off-Site', 'Contingent, On-Site', 'Contractor, Off-Site', 'Contractor, On-Site', 'Supplier Employee', 'Salary', 'Wage']
export const SCBM_SUPPLIER_TYPE_ALLOWED = ['Contingent, Off-Site', 'Contingent, On-Site', 'Contractor, Off-Site', 'Contractor, On-Site', 'Supplier Employee']
export const SCBM_EMPLOYEE_TYPE_ALLOWED = ['Wage', 'Salary']
export const SCBM_REVIEW_TYPE_ALLOWED = ['Contingent, Off-Site', 'Contingent, On-Site', 'Contractor, Off-Site', 'Contractor, On-Site', 'Supplier Employee', 'Supplier Employee', 'Salary', 'Wage']
export const SCBM_STATES_SURVEY = { SUBMITTED: 'Submitted', ASSIGNED: 'Assigned', CREATED: 'Created', PROGRESS: 'In Progress' }
export const SCBM_STATES_CAMPAIGN = { OPEN: 'Open', CLOSED: 'Closed', DRAFT: 'Draft' }
export const SCBM_ADMIN = 'SCBM_ADMIN'
export const SCBM_ADMIN_INDIRECT = 'IMS_SCBM_ADMIN'
export const CTPAT_ADMIN = 'CTPAT_ADMIN'
export const COC_ADMIN = 'COC_ADMIN'
export const SCF_ADMIN = 'SCF_ADMIN'
export const CM_ADMIN = 'CM_ADMIN'
export const EM_ADMIN = 'EM_ADMIN'
export const TPSMEX_ADMIN = 'TPSMEX_ADMIN'
export const TPS_ADMIN = 'TPS_ADMIN'
export const CBAM_ADMIN = 'CBAM_ADMIN'
export const SBTP_ADMIN = 'SBTP_ADMIN'
export const AEU_ADMIN = 'AEU_ADMIN'
export const COO_ADMIN = 'COO_ADMIN'
export const LHR_ADMIN = 'LHR_ADMIN'
export const ST_ADMIN = 'ST_ADMIN'
export const OS_ADMIN = 'OS_ADMIN'
export const CM_IF_ADMIN = 'CM_IF_ADMIN'
export const EM_IF_ADMIN = 'EM_IF_ADMIN'
export const SELFSERVICE_ADMIN = 'SELFSERVICE_ADMIN'
export const SAD_ADMIN = 'SAD_ADMIN';
export const CRS_ADMIN = 'CRS_ADMIN';
export const CRS_ADMIN_ROLES = [SCBM_ADMIN, CTPAT_ADMIN, CM_ADMIN, LHR_ADMIN, ST_ADMIN, OS_ADMIN, TPSMEX_ADMIN, TPS_ADMIN, AEU_ADMIN, COO_ADMIN, OS_ADMIN, CBAM_ADMIN, SBTP_ADMIN,SAD_ADMIN]
export const CRS_SURVEY_CODES = { SCBM: 'SCBM', CTPAT: 'CTPAT', COC: 'COC', SCF: 'SCF', SCBM_INDIRECT: 'SCBM-Indirect', CM: 'CM', EM: 'EM', LHR: 'LHR', TPS: 'TPS', ST: 'ST', OS: 'OS', COO: 'COO', AEU: 'AEU', TPSMEX: 'TPSMEX', CBAM: 'CBAM', SBTP: 'SBTP', SAD: 'SAD' }
export const CRS_CAMPAIGN_STATUS = [{ label: 'Open', checked: false }, { label: 'Closed', checked: false }]
export const CRS_REQUEST_STATUS_OBJ = { EMAIL_PENDING: 'Email Pending', REQUEST_CREATED: 'Request Created', IN_PROCESS: 'In Process', COMPLETE: 'Complete', INCOMPLETE: 'Incomplete' }
export const CRS_REQUEST_STATUS = [{ label: CRS_REQUEST_STATUS_OBJ.EMAIL_PENDING, checked: true }, { label: CRS_REQUEST_STATUS_OBJ.REQUEST_CREATED, checked: true }, { label: CRS_REQUEST_STATUS_OBJ.IN_PROCESS, checked: true }, { label: CRS_REQUEST_STATUS_OBJ.COMPLETE, checked: false }, { label: CRS_REQUEST_STATUS_OBJ.INCOMPLETE, checked: false }]
export const CRS_REQUEST_SELECTION = [{ id: 'request', code: 'Request', selected: true }, { id: 'campaign', code: 'Campaign', selected: false }]
export const CRS_UNIT_TYPE_SELECTION = [{ id: 'DU', label: 'Deere Units', checked: true }, { id: 'NDU', label: 'Non Deere Units', checked: false }]
export const DOWNLOAD_LINK = "Download Results"
export const DOWNLOAD_ERROR = "No data to download from the database"
export const SCBM_CODE = 'SCBM'
export const SCBM_INDIRECT = 'SCBM-Indirect'
export const NO_INFORMATION = "No information to display"
export const CLOSING_ALERT = 'Are you sure you wish to close this campaign ?'
export const NO_SUPPLIERS = 'No suppliers related to user '
export const CRS_SEARCH_DEFAULT_TITLE_PAGE = 'Search Requests'
export const CRS_SEARCH_CAMPAIGNS_TITLE_PAGE = 'Search Campaigns'
export const CTPAT = 'CTPAT'
export const COC = 'COC'
export const SCF = 'SCF'
export const CM = 'CM'
export const EM = 'EM'
export const LHR = 'LHR'
export const AEU = 'AEU'
export const TPS = 'TPS'
export const TPSMEX = 'TPSMEX'
export const CBAM = 'CBAM'
export const SBTP = 'SBTP'
export const COO = 'COO'
export const ST = 'ST'
export const OS = 'OS'
export const SAD = 'SAD';
export const EWDC = 'EWDC';
export const DEFAULT_LANGUAGE = 'en'
export const DEFAULT_LANGUAGE_CODE = "en_EN";
export const DEFAULT_LANGUAGE_ENGLISH = 'English';
export const MUST_CLICK_SUBMIT = "You must click SUBMIT at the bottom of this screen to complete your conflict mineral submission.";
export const DEFAULT_PART_COLUMN = "Default Part Columns:"
export const CTPAT_SECTIONS_TO_VALIDATE = ['ctpat_sec2', 'ctpat_sec3', 'ctpat_sec4', 'ctpat_sec5', 'ctpat_sec6', 'ctpat_sec7', 'ctpat_sec8', 'ctpat_sec9'];
export const CTPAT_QUESTIONS_TO_VALIDATE = ['ctpat_que1', 'ctpat_que2'];

export const DAYS_OF_THE_WEEK = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

export const DEFAULT_NOT_CONFIG = {
    active: true,
    remainderDay: 'Monday',
    numberRemainders: 1,
    initNotificationSubj: 'John Deere Supplier Capability Business Monitoring Request - ACTION REQUIRED',
    remNotificationSubj: 'REMINDER - John Deere Supplier Capability Business Monitoring Request - ACTION REQUIRED',
    daysFirstRem: '7',
    emailEnabled: true,
    delinquentEnabled: false,
    delinquentPrefix: "",
    sendInitialNotification: true
}
export const INIT_NOTIFICATION_QUESTION = "Do you want to send an initial notification?";
export const NO_CONTACTS = 'No Contacts'
export const DAYS_WEEKS = 'Days/Week'
export const SUPPLIER_NUMBER ='Supplier Number'
export const NON_DEERE_COMPANY_CONTACT= 'Company Contact'
export const  DEERE_CONTACT = 'Deere Contact'

export const TABLE_SECT = 'TABLE_SECT';
export const FLEX_TABLE = 'FLEX_TABLE';
export const OPEN = 'OPEN';
export const TIER2_BOUNDARIES_TYPES = ['State', 'Province', 'Administrative region', 'Autonomous region', 'Municipality']
export const IMPORTED_FILE_EXTENSIONS = ['xlsx', 'xls', 'csv']
export const SUPPLIER_NUMBER_CM_COLUMN = 'Corporate Supplier Number'
export const DEERE_PART_CM_COLUMN = 'Deere Part Number'
export const SUPPLIER_NUMBER_EM_COLUMN = 'Corporate Supplier Number'
export const DEERE_PART_EM_COLUMN = 'Deere Part Number'
export const TEMPLATE_COLUMNS = [{ 'Corporate Supplier Number': '', 'Deere Part Number': '' }]
export const SUPPLIER_COLUMN = 'Supplier';
export const PART_TPS_COLUMN = 'Part';
export const DESCRIPTION_TPS_COLUMN = 'Description';
export const HSCODE_TPS_COLUMN = 'HSCode';
export const TEMPLATE_TPS_COLUMNS = [{ Supplier: '', Part: '', Description: '', HSCode: '' }]
export const PART_SUPPLIER_NUMBER_COLUMN = 'Supplier';
export const PART_COLUMN = 'Part';
export const PART_DESCRIPTION_COLUMN = 'Description';
export const PART_HSCODE_COLUMN = 'HSCode';
export const PART_SECTION_COLUMN = 'Section';
export const NON_DEERE_SUPPLIER_NUMBER_COLUMN = 'Supplier Number';
export const NON_DEERE_SUPPLIER_NAME_COLUMN = 'Supplier Name';
export const NON_DEERE_PART_NUMBER_COLUMN = 'Part Number';
export const NON_DEERE_PART_DESCRIPTION_COLUMN = 'Part Description';
export const NON_DEERE_SUPPLIER_EMAIL_COLUMN = 'Supplier Contact Email(s)';
export const NON_DEERE_COMPANY_EMAIL_COLUMN = 'Unit/Company Contact Email(s)'; 
export const PART_FIRST_NAME_COLUMN = 'Employee First Name';
export const PART_LAST_NAME_COLUMN = 'Employee Last Name';
export const PART_RACF_COLUMN = 'John Deere ID (RACF)';
export const EMP_REQ = "Employee Requested";
export const EMP_DEC = "Employee Declared";
export const PART_TEMPLATE_COLUMNS = [{ Supplier: '', Part: '', Description: '', HSCode: '', Section: '' }];
export const TEMPLATE_NON_DEERE_COLUMNS = [{"Supplier Number": "", "Supplier Name": "", "Part Number": "", "Supplier Contact Email(s)": "", "Unit/Company Contact Email(s)": ""}]
export const TEMPLATE_NON_PART_NON_DEERE_COLUMNS = [{"Supplier Number": "", "Supplier Name": "", "Supplier Contact Email(s)": "", "Unit/Company Contact Email(s)": ""}]
export const SUPPLIER_NUMBER_COO_COLUMN = 'Supplier';
export const PART_COO_COLUMN = 'Part';
export const DESCRIPTION_COO_COLUMN = 'Description';
export const UNIT_CODE_COO_COLUMN = 'Unit Code';
export const TEMPLATE_COO_COLUMNS = [{ Supplier: '', Part: '', Description: '', 'Unit Code': ''}]
export const TEMPLATE_NAME = 'supplier_part_template'
export const NON_DEERE_NON_PART_TEMPLATE_NAME = 'supplier_template'
export const BUSSINESS_ROLES = [
    { id: 1, description: "Company Officer(CEO,etc)"},
    { id: 2, description: "Operations" },
    { id: 3, description: "Accounting/Finance" },
    { id: 4, description: "Key Contact" },
    { id: 5, description: "Education and Training" },
    { id: 7, description: "Sales" },
    { id: 8, description: "Achieving Excellence" },
    { id: 9, description: "Engineer" },
    { id: 10, description: "Product Development" },
    { id: 11, description: "JD CROP" },
    { id: 12, description: "Logistics" },
    { id: 14, description: "EDI" },
    { id: 15, description: "Customer Service" },
    { id: 16, description: "Quality" },
    { id: 17, description: "Warranty" },  
    { id: 18, description: "Union" }, 
    { id: 19, description: "Expeditor / Scheduler" }, 
    { id: 21, description: "Trade Preference" },
    { id: 22, description: "Tooling Coordinator" },
    { id: 23, description: "JDSN Web EDI" },
    { id: 24, description: "Engineering System Contact" },
    { id: 25, description: "Surcharge Coordinator" },
    { id: 26, description: "Reject Notification (NCCA)" },
    { id: 27, description: "Compliance" },
    { id: 28, description: "eCatalog Manager" },  
    { id: 29, description: "Supp Collab Quality Engineer" },
    { id: 30, description: "Supp Collab Quote Analyst" },
    { id: 31, description: "Supp Collab Supplier Rep" },
    { id: 32, description: "Price Change Analyst" },
    { id: 33, description: "Product Chemical Compliance" },  
    { id: 34, description: "Sustainability" }
]

export const SRO_ROLES = [{ description: "COMMODITY", id: "COMMODITY", checked: false }, { description: "COMPLIANCE", id: "COMPLIANCE", checked: false }, { description: "SBM", id: "SBM", checked: false }, { description: "SRO", id: "SRO", checked: false }, { description: "SDE", id: "SDE", checked: false }, { description: "GCQM", id: "GCQM", checked: false }, { description: "AFTERMARKET", id: "AFTERMARKET", checked: false }]

export const SURVEY_CODE_MAP_PATH = new Map()
    .set(CRS_SURVEY_CODES.SCBM, "scbm")
    .set(CRS_SURVEY_CODES.SCBM_INDIRECT, "scbm")
    .set(CRS_SURVEY_CODES.CM, "cm")
    .set(CRS_SURVEY_CODES.EM, "em")
    .set(CRS_SURVEY_CODES.TPS, "tps")
    .set(CRS_SURVEY_CODES.TPSMEX, "tps")
    .set(CRS_SURVEY_CODES.ST, "st")
    .set(CRS_SURVEY_CODES.OS, "os")
    .set(CRS_SURVEY_CODES.COO, "coo")
    .set(CRS_SURVEY_CODES.CBAM, "surveypart")
    .set(CRS_SURVEY_CODES.SBTP, "surveypart")
    .set(CRS_SURVEY_CODES.SAD, "surveypart")
    .set("DEFAULT", "survey");
export const CM_RESPONSE_STATUS = { SUBMITTED: 'Submitted' }
export const EM_RESPONSE_STATUS = { SUBMITTED: 'Submitted' }
export const SECTIONS_TO_RENDER_COMPONENT = [{ SURVEY: "TPS", TYPE: "COMPONENT", CODE: "TPS_SEC4" }, { SURVEY: "TPS", TYPE: "COMPONENT", CODE: "TPS_SEC5" }]
export const DEFAULT_GRID_COLLUMNS = 12


//SubTier Survey
export const ADDRESS_TEMPLATE_COLUMNS = ["Supplier Name", "Street Address", "Country", 'City', "State", "Postal Code", "Tier Level", "Product Type", "U.S. SUPPLIERS ONLY\r\nIs this entity considered a diverse enterprise?\r\n(Y/N)"];
export const OBJECT_KEYS_SUPPLIER_DATA = ["supplierName", "streetAddress", "country", "city", "state", "postalCode", "tierLevel", "productType", "isDiverseEnterprise"];

export const INVALID_FILE_ERR = "Invalid File - Please try with a valid template. It can be downloaded by clicking on the 'Address Template' button below.";
export const INVALID_COUNTRY_ERR = "Some of the country and state names on the uploaded sheet could not be recognized by the system, so those values were removed. The emptied values are highlighted in the table below. Please use the dropdown menu to make your selection.";
export const EMPTY_VALUES_ERR = "Please provide values for all the fields before proceeding to submit.";
export const NO_DATA_ERR = "Please provide supplier data before proceeding to submit."

export const SUBTIER_TEMPLATE_POPUP = "Please document this supplier's tier level within YOUR supply chain as it relates to John Deere business only.Tier 1 = These are the direct suppliers of YOUR final product.Tier 2-Tier 4 = These are suppliers or subcontractors to your Tier I suppliers."
export const TIER_LEVEL_TOOLTIP = "Please document this supplier's tier level within YOUR supply chain as it relates to John Deere business only.<br/><br/>Tier 1 = These are the direct suppliers of YOUR final product.<br/><br/>Tier 2-Tier 4 = These are suppliers or subcontractors to your Tier I suppliers.";
export const PRODUCT_TYPE_TOOLTIP = "Please provide the product type your suppliers provide as an input to John Deere business.";

export const ADDRESS_TEMPLATE_NAME = 'CRS Large Scale Sub-Tier Supplier Survey Template';

export const TPS_COMPONENT_CODE_SECTIONS = { RESPONSES_SEC: 'TPS_SEC1', SUPPLIERS_SEC : 'TPS_SEC4', PARTS_SECTIONS:'TPS_SEC5', AGREEMENT_SEC:'TPS_SEC6' }
export const TPSMEX_COMPONENT_CODE_SECTIONS = { RESPONSES_SEC: 'TPSMEX_SEC1', SUPPLIERS_SEC: 'TPSMEX_SEC3', IMPORTER_EXPORTER_SEC: 'TPSMEX_SEC4', PARTS_SECTIONS: 'TPSMEX_SEC5' }
export const COO_COMPONENT_CODE_SECTIONS = { RESPONSES_SEC: 'COO_SEC1', AUTHORIZER_SEC: "COO_SEC2", SUPPLIERS_SEC: 'COO_SEC3', PARTS_SECTIONS: 'COO_SEC5' }
export const SURVEYPART_SECTION_CODES = {RESPONSES_SEC : 'CBAM_SEC1', AUTHORIZER_SEC:'CBAM_SEC2', SUPPLIERS_SEC: 'CBAM_SEC3', PARTS_SECTIONS: 'CBAM_SEC4'}
export const TPS_PART_STATUSES = {IN_PROGRESS : 'IN PROGRESS', SUBMITTED:'SUBMITTED'}
export const TPS_RESPONSE_STATUSES = {IN_PROCESS : 'In Process', SUBMITTED:'Submitted'}
export const TPS_MX_AUTHORIZOR_SECTION = "TPSMEX_SEC2"
export const TPS_MX_AUTHORIZOR_SECTION_QUESTION = "TPSMEX_SEC2_Q002"
export const COO_RESPONSE_STATUSES = {IN_PROCESS : 'In Process', SUBMITTED:'Submitted'}
export const SURVEY_RESPONSE_STATUSES = {IN_PROCESS : 'In Process', SUBMITTED:'Submitted'}
export const SECTION_TYPES = ["COMPONENT"]
export const SCBM_SECCIO_CODES = {BS:'SCBM_SEC1',LB:'SCBM_SEC2',CC:'SCBM_SEC3',FL:'SCBM_SEC4',AC:'SCBM_SEC5', T2:'SCBM_SEC6', OF:'SCBM_SEC7', CS: 'SCBM_SEC8', OTH: 'SCBM_SEC9', NOTE: 'SCBM_SEC10'};
export const SCBM_CHECK_CODE_EXCLUDED = ['SCBM_SEC3_Q016','SCBM_SEC3_Q017','SCBM_SEC3_Q018'];
export const ST_CATALOGUE_PRODUCTTYPE = 'Product Type';
export const ST_CATALOGUE_TIERLEVEL = 'Tier Level';
export const ST_CATALOGUE_DIVERSITYTYPE = 'Diversity Type';
export const DATE_FORMAT='DD-MMM-YY';

export const OS_CONTACT_PARENT = "OS_SEC2_Q001";
export const OS_CONTACT_PARENT_ANS = "1";

export const OS_CONTACT_QUE_KEYS = {
  "OS_SEC2_Q002~MULTI": "lastName",
  "OS_SEC2_Q003~MULTI": "firstName",
  "OS_SEC2_Q004~MULTI": "ownershipPercentage",
  "OS_SEC2_Q005~MULTI": "isGovtAffiliated",
  "OS_SEC2_Q006~MULTI": "countryOfCitizenship",
  "OS_SEC2_Q007~MULTI": "jobTitle",
  "OS_SEC2_Q008~MULTI": "positionWithGovtAgency",
  "OS_SEC2_Q009~MULTI": "nameOfGovtAgency"
};

export const NON_OKTA_USER = "EXTUSER";
export const LBL_SUCCESS = "Success";
export const LBL_DANGER = "danger";
export const LBL_CONFIRMATION = "Confirmation";
export const LBL_MESSAGE = "Message";
export const LBL_CLOSE = "Close";
export const LBK_OK = "Ok";
export const LBL_ERROR = "Error"
export const SUPPLIER_IS_VALID = "Supplier Number is valid.";
export const SUPPLIER_IS_INVALID = "Supplier Number is invalid.";
export const SUPPLIER_ALREADY_EXISTS = "This Supplier is already present in this campaign.";
export const CM_ADMIN_SEC = 'CM_SEC_GEN1';
export const CM_ADMIN_QUESTION = 'CM_SEC_GEN1_1';
export const CM_ADMIN_QUE_LBL = 'Please provide statement to explain why you are submitting on behalf of supplier?';
export const EM_ADMIN_SEC = 'EM_SEC_GEN1';
export const EM_ADMIN_QUESTION = 'EM_SEC_GEN1_1';
export const EM_ADMIN_QUE_LBL = 'Please provide statement to explain why you are submitting on behalf of supplier?';
export const ST_ADMIN_CASES = {
  INCOMPLETE:'Incomplete',
  UNIQUE:'Unique',
  LIKENAME:'LikeName'
};

export const AEU_PDF_ERROR = 'A PDF file was not found for this campaign';
export const COO_TOOLTIP_DUAL_SOURCE = "Add additional country(s) for dual sourced part.";
export const GENERIC_CANNOT_PROVIDE_INFORMATION_POPUP_TITLE = "please select a reason";
export const COO_COUNTRY_OVERRIDE_CONFIRMATION = "Selected part(s) have country of origin assigned to it. This action will override the existing selection. Do you wish to continue ?";

export const TPMEX_EXPORTER_PRODUCER_IMPORTER = [
  { header: 'Exporter Details', questions: [ 'TPSMEX_SEC4_Q004', 'TPSMEX_SEC4_Q005', 'TPSMEX_SEC4_Q006', 'TPSMEX_SEC4_Q007' ] },
  { header: 'Producer Details', questions: [ 'TPSMEX_SEC4_Q008', 'TPSMEX_SEC4_Q009', 'TPSMEX_SEC4_Q010', 'TPSMEX_SEC4_Q011' ] },
  { header: 'Importer Details',
    name: 'INDUSTRIAS JOHN DEERE, S DE RL DE CV',
    address: 'BOULEVARD DIAZ ORDAZ 500, COLONIA LA LEONA, SAN PEDRO GARZA GARCIA, NUEVO LEON, C.P. 66210 MEXICO | TAX ID: IJD840224QD2',
    email: 'guajardoblancaguadalupe@johndeere.com',
    phone: 'Telephone: +52 (81) 8288-8295'
  }
];
export const EXPORTER_DETAILS = 'Exporter Details';
export const PRODUCER_DETAILS = 'Producer Details';
export const IMPORTER_DETAILS = 'Importer Details';
export const TPSMEX_ORIGIN_CRITERION_OPTIONS = [ "A", "B", "C", "D" ];
export const ORIGIN_CRITERION_COMMENT_DEPS = ["A", "D"];
export const TPSMEX_PARTS_SUBSECTIONS_ERR = { COUNTRY: "Country of Origin", ORIGIN: "Origin Criterion", COMMENTS: "Comments for Origin Criterion" };
export const CRS_INTERFACTORY_SURVEYS = ['AEU'];
export const NOTIFIC_TEMPLATE_CODE_INITIAL = "INITIAL";
export const NOTIFIC_TEMPLATE_CODE_REMINDER = "REMINDER";
export const PARTS_TABLE_WORKSHEET_NAME = 'Parts Table';
export const PARTS_TABLE_WORKSHEET_NAME_EMPLOYEE = 'Employee Table';
export const PARTS_TABLE_SELECTIONS_SHEET_NAME = 'selectionsList';
export const PARTS_TABLE_UPLOAD_WARNING = "Some parts from your uploaded data are linked to different responses. This data won't be captured. If you want this data to get captured select the correct response before uploading. Click 'Confirm' if you want to continue with the upload."
export const HELP_DOC_PDF_NAME = 'JDSN_helpDoc.pdf';
export const DEFAULT_COMPANY = "John Deere";
export const DATA_VALIDATE_SUCCESS = "Data Validation Successful.";
export const FILTER_VARIANTS = { SUPPLIER: 'supplier', NONDEERESUPPLIER: 'nonDeereSupplier', DEERECONTACT: 'deereContact', COMPANYCONTACT: 'companyContact' };
export const FILTER_TITLES = { SUPPLIER: 'Supplier', NONDEERESUPPLIER: 'Non-Deere Supplier', DEERECONTACT: 'Deere Contact', COMPANYCONTACT: 'Company Contact' };
export const FILTER_ID = { SUPPLIER: 'supplier_filter', NONDEERESUPPLIER: 'non_deere_supplier_filter', DEERECONTACT: 'deere_contact_filter', COMPANYCONTACT: 'company_contact_filter' };
export const COMPANY_TYPES = { DEERE: 'deere', NONDEERE: 'nonDeere' };
export const API_ABORT_ERROR = 'AbortError'
export const PARTS_TABLE_ACCESSOR_KEYS = { SUPPLIER_NUM: 'supplierNumber', DEERE_PART_NUM: 'deerePartNumber', DEERE_PART_DESC: 'deerePartDesc', HS_CODE: 'hsCode', PART_NUM: 'partNumber', PART_DESC: 'partDesc', STATUS: 'statusResponse' };
export const PART_POPUP_HEADER = { PART: "Part", DEEREPART: "Deere Part", DECLARED: 'Declared?', HSCODE: "HS Code", SECTION: 'Section' };
export const PART_POPUP_ACCESSOR_KEYS = { PART: "partNumber", DEEREPART: "deerePartNumber", DECLARED: 'declared', HSCODE: "hsCode", SECTIONNAME: "sectionName"};
export const SURVEY_EXT_ROUTES = new Map().set(CRS_SURVEY_CODES.ST, "stext").set(CRS_SURVEY_CODES.CBAM, "surveypartext").set(CRS_SURVEY_CODES.CM, "cmext").set("DEFAULT", "surveyext");
export const EXT_REQUEST_CONTEXT = 'surveyLogin';
export const SURVEYPART_SECTION_TYPES = {RESPONSES: 'component_response',  QUESTIONS: 'component_questions', SUPPLIER: 'component_supplier', PART: 'component_part', ATTACHMENTS: 'component_attachment', ADMIN_COMMENTS:'admin_comments' };
export const SAMPLE_DATA_CODE = 'partTableSample'
export const FILE_EXTENSIONS_TO_EXCLUDE = ["exe", "sql", "js", "cmd"];
export const FILE_EXTENSIONS_TO_INCLUDE_AT_SURVEY_PART = ["pdf", "jpg", "jpeg", "png"];
export const LBL_NO_DOCS = "No Documents uploaded."
export const FILE_DELETE_RESPONSE = "File deleted successfully";
export const COLUMN_TYPE ={ SELECT: 'SELECT', NUM: 'NUM' }
export const CRS_SURVEY_TEMPLATES = { CM: 'CM', GENERIC: 'GENERIC', PART: 'PART_RELATED' };
export const CRS_SURVEY_TEMPLATE_PATHS = { CM: 'cm', GENERIC: 'survey', PART: 'surveyPart' };
export const SELF_SERVICE_PART_DESCRIPTION ="Deere Part Description";
export const SELF_SERVICE_HTS_CODE = "HTS code"
export const SELF_SERVICE_HSCODE="Harmonized Tariff Schedule Code";
export const SELF_SERVICE_STEP_TITLES = {
  SURVEY_STEP: "New Survey",
  LANGUAGE_STEP: "Languages",
  SURVEYTRANSLATION_STEP: "Survey Title Translations",
  AGREEMENT_STEP: "Disclaimer / Agreement",
  SECTION_STEP: "Sections",
  QUESTION_STEP: "Questions",
  HELPDOCSTEP: "Help Document",
  NOTIFICATION_EMAIL: "Notification Email",
  REPORT_CONFIGURATION_STEP: "Report Configuration",
  REVIEW_STEP: "Review & Publish",
  SAVEORPUBLISH_STEP: "Finish"
};

export const DEFAULT_COLUMNS = [
  {
    columnNames: "Supplier",
    isNonDeere: false,
    translations: [
      { locale: "zh_CN", language: "Chinese", text: "供应商" },
      { locale: "fr_FR", language: "French", text: "Fournisseur" },
      { locale: "de_DE", language: "German", text: "Lieferant" },
      { locale: "es_MX", language: "Spanish", text: "Proveedor" },
      { locale: "pt_PT", language: "Portuguese", text: "Fornecedor" },
    ],
  },
  {
    columnNames: "Part",
    isNonDeere: false,
    translations: [
      { locale: "zh_CN", language: "Chinese", text: "零件" },
      { locale: "fr_FR", language: "French", text: "Pièce" },
      { locale: "de_DE", language: "German", text: "Teil" },
      { locale: "es_MX", language: "Spanish", text: "Repuesto" },
      { locale: "pt_PT", language: "Portuguese", text: "Peça" },
    ],
  },
  {
    columnNames: "Description",
    isNonDeere: false,
    translations: [
      { locale: "zh_CN", language: "Chinese", text: "描述" },
      { locale: "fr_FR", language: "French", text: "Description" },
      { locale: "de_DE", language: "German", text: "Beschreibung" },
      { locale: "es_MX", language: "Spanish", text: "Descripción" },
      { locale: "pt_PT", language: "Portuguese", text: "Descrição" },
    ],
  },
  {
    columnNames: "Supplier Number",
    isNonDeere: true,
    translations: [
      { locale: "zh_CN", language: "Chinese", text: "供应商编号" },
      { locale: "fr_FR", language: "French", text: "Numéro de fournisseur" },
      { locale: "de_DE", language: "German", text: "Lieferantennummer" },
      { locale: "es_MX", language: "Spanish", text: "Número de proveedor" },
      { locale: "pt_PT", language: "Portuguese", text: "Número de fornecedor" },
    ],
  },
  {
    columnNames: "Supplier Name",
    isNonDeere: true,
    translations: [
      { locale: "zh_CN", language: "Chinese", text: "供应商名称" },
      { locale: "fr_FR", language: "French", text: "Nom du fournisseur" },
      { locale: "de_DE", language: "German", text: "Lieferantenname" },
      { locale: "es_MX", language: "Spanish", text: "Nombre del proveedor" },
      { locale: "pt_PT", language: "Portuguese", text: "Nome do Fornecedor" },
    ],
  },
  {
    columnNames: "Part Number",
    isNonDeere: true,
    translations: [
      { locale: "zh_CN", language: "Chinese", text: "零件号" },
      { locale: "fr_FR", language: "French", text: "Référence" },
      { locale: "de_DE", language: "German", text: "Teilenummer" },
      { locale: "es_MX", language: "Spanish", text: "Número de referencia" },
      { locale: "pt_PT", language: "Portuguese", text: "Número da Peça" },
    ],
  },
  {
    columnNames: "Part Description",
    isNonDeere: true,
    translations: [
      { locale: "zh_CN", language: "Chinese", text: "零件说明" },
      { locale: "fr_FR", language: "French", text: "Description de la pièce" },
      { locale: "de_DE", language: "German", text: "Teilebeschreibung" },
      { locale: "es_MX", language: "Spanish", text: "Descripción de la pieza" },
      { locale: "pt_PT", language: "Portuguese", text: "Descrição da Peça" },
    ],
  },
  {
    columnNames: "Supplier Contact Email(s)",
    isNonDeere: true,
    translations: [
      { locale: "zh_CN", language: "Chinese", text: "供应商联系人电子邮件" },
      { locale: "fr_FR", language: "French", text: "E-mail(s) de contact du fournisseur" },
      { locale: "de_DE", language: "German", text: "E-Mail-Adresse(n) des Lieferantenkontakts" },
      { locale: "es_MX", language: "Spanish", text: "Correo(s) de contacto del proveedor" },
      { locale: "pt_PT", language: "Portuguese", text: "E-mail(s) de Contacto do Fornecedor" },
    ],
  },
  {
    columnNames: "Unit/Company Contact Email(s)",
    isNonDeere: true,
    translations: [
      { locale: "zh_CN", language: "Chinese", text: "单位/公司联系人电子邮件" },
      { locale: "fr_FR", language: "French", text: "Courriel(s) de contact de l'unité/de la société" },
      { locale: "de_DE", language: "German", text: "E-Mail-Adresse(n) des Referats/Unternehmens" },
      { locale: "es_MX", language: "Spanish", text: "Correo electrónico de contacto de la unidad/empresa" },
      { locale: "pt_PT", language: "Portuguese", text: "E-mail(s) de Contacto da Unidade/Empresa" },
    ],
  },
];

export const DEFAULT_PART_COLUMNS = DEFAULT_COLUMNS.map(c => c.columnNames);

export const SELF_SERVICE_STEPS = [
  { id: 0, step: "Step 1", title: SELF_SERVICE_STEP_TITLES.SURVEY_STEP },
  { id: 1, step: "Step 2", title: SELF_SERVICE_STEP_TITLES.LANGUAGE_STEP },
  { id: 2, step: "Step 3", title: SELF_SERVICE_STEP_TITLES.SURVEYTRANSLATION_STEP },
  { id: 3, step: "Step 4", title: SELF_SERVICE_STEP_TITLES.AGREEMENT_STEP },
  { id: 4, step: "Step 5", title: SELF_SERVICE_STEP_TITLES.SECTION_STEP },
  { id: 5, step: "Step 6", title: SELF_SERVICE_STEP_TITLES.QUESTION_STEP },
  { id: 6, step: "Step 7", title: SELF_SERVICE_STEP_TITLES.HELPDOCSTEP },
  { id: 7, step: "Step 8", title: SELF_SERVICE_STEP_TITLES.NOTIFICATION_EMAIL },
  { id: 8, step: "Step 9", title: SELF_SERVICE_STEP_TITLES.REPORT_CONFIGURATION_STEP },
  { id: 9, step: "Step 10", title: SELF_SERVICE_STEP_TITLES.REVIEW_STEP },
  { id: 10, step: "Step 11", title: SELF_SERVICE_STEP_TITLES.SAVEORPUBLISH_STEP },
];

export const SELF_SERVICE_LANDING_DELETE_CONFIRMATION ="Deleting the survey will delete all related configuration (questions, translations, sections, etc.) Are you sure you want to proceed with the delete?"
export const PROMOTE_SURVEY_TITLE = "Promote Survey";
export const PROMOTE_NEW_SURVEY_OPTION = "new";
export const PROMOTE_EXISTING_SURVEY_OPTION = "existing";
export const PROMOTE_NEW_SURVEY_LABEL = "Promote to a new survey";
export const PROMOTE_EXISTING_SURVEY_LABEL = "Promote to an existing survey";
export const PROMOTE_EXISTING_SURVEY_FETCH_ERROR = "Error fetching existing surveys for promotion.";
export const PROMOTE_EXISTING_SURVEY_SELECT_LABEL = "Select Survey";
export const CONTINUE_BTN = "Continue";
export const YES = "Yes";
export const NO = "No";
export const SECTION_TITLE = "Section Title";
export const LANGUAGE_TITLE = "Current language available for your survey";
export const CANCEL_BTN = "Cancel";
export const SAVE_BTN = "Save";
export const ADD_NEW_SECTION = "Add New Section";
export const SECTION_NAME_LABEL = "Section Name";
export const SECTION_NAME = "Please enter the section name here...";

export const SECTION_DESCRIPTION_LABEL = "Section Description";
export const SECTION_DESCRIPTION = "Please enter the section description here..."
export const ADD_NEW_LINK = "Add New Link";
export const ADD_NEW_COLUMN = "Add New Column";
export const LINK_LABEL_PLACEHOLDER = "Please enter the label here...";
export const LINK_LANGUAGE_PLACEHOLDER = "Please enter the language here...";
export const LINK_PLACEHOLDER = "Please enter the Link here..."
export const LINK_LABEL_LABEL= "Label";
export const LINK_LABEL_LANGUAGE= "Language";
export const LINK_LABEL_LINK= "Link";
export const DESCRIPTION = "description";
export const LONG_DESCRIPTION = "longDescription";
export const DETAILS = "Details";
export const LINKS = "Links";
export const SELECT = "Select";
export const TRANSLATIONS = "Translations";
export const PREVIOUS_BTN="Previous";
export const NEXT_BTN="Next";
export const PUBLISH_BTN="Publish";
export const LANGUAGE_PLACEHOLDER = "Please provide the translation here...";
export const QUESTION_TYPES = {
  OPEN_SMALL: "OPEN_SMALL",
  SELECT: "SELECT",
  CHECK: "CHECK",
  DATEPICKER: "DATEPICKER",
  RADIO: "RADIO",
  FILE: "FILE",
  OPTION: "OPTION",
  VIEWER: "VIEWER",
  SEL_CNTRY: "SEL_CNTRY",
  SEL_CTY_UW: "SEL_CTY_UW",
  SEL_STATE: "SEL_STATE",
  OPEN: "OPEN",
  TABLE_MON: "TABLE_MON",
  FORMULA: "FORMULA",
  TABLE_SECT: "TABLE_SECT",
  TABLE_BS: "TABLE_BS",
  PERC_SALES: "PERC_SALES",
  OPEN_TITLE: "OPEN_TITLE",
  DATE_SECT: 'DATE_SECT',
  FLEX_TITLE: 'FLEX_TITLE',
  TITL_POPUP:'TITL_POPUP',
  CHEK_POPUP: 'CHEK_POPUP',
  NUM: 'NUM',
  MULT_CNTRY: 'MULT_CNTRY',
  MULTI_SEL: "MULTI_SEL",
  LABEL: "LABEL",
  MATRIX: "MATRIX"
};
export const REPORT_EXCLUDED_QUESTION_TYPES = [
  QUESTION_TYPES.FILE,
  QUESTION_TYPES.TABLE_SECT,
  QUESTION_TYPES.TABLE_MON,
  QUESTION_TYPES.TABLE_BS,
];

export const SELF_SERVICE_QUE_TYPES_GENERIC = [
  { code: QUESTION_TYPES.OPEN_SMALL, type: "Open Text", needSelections: false, helpText: "Use this to create a question with a single-line text input for users to provide short answers." },
  { code: QUESTION_TYPES.SELECT, type: "Option", needSelections: true, helpText: "Use this to create a question where users can select one or more options from a predefined list." },
  { code: QUESTION_TYPES.CHECK, type: "Check", needSelections: true, helpText: "Use this to create a question with checkboxes, allowing users to select multiple options." },
  { code: QUESTION_TYPES.DATEPICKER, type: "Date", needSelections: false, helpText: "Use this to create a question where users can select a date from a calendar picker." },
  { code: QUESTION_TYPES.RADIO, type: "Radio", needSelections: true, helpText: "Use this to create a question with radio buttons, allowing users to select only one option from a list." },
  { code: QUESTION_TYPES.OPEN, type: "Open Multiline", needSelections: false, helpText: "Use this to create a question with a multi-line text input for users to provide detailed answers." },
  { code: QUESTION_TYPES.FILE, type: "File Upload", needSelections: false, helpText: "Use this to create a question where users can upload files as part of their response." },
  { code: QUESTION_TYPES.VIEWER, type: "File Viewer", needSelections: false, helpText: "Use this to display uploaded files for users to view as part of the question." },
  { code: QUESTION_TYPES.SEL_CNTRY, type: "Option Country", needSelections: false, helpText: "Use this to create a question where users can select a country from a predefined list." },
  { code: QUESTION_TYPES.SEL_CTY_UW, type: "Option Country with unknown", needSelections: false, helpText: "Use this to create a question where users can select a country from a predefined list, including an option for unknown." },
  { code: QUESTION_TYPES.SEL_STATE, type: "Option State", needSelections: false, helpText: "Use this to create a question where users can select a state or region from a predefined list." },
  { code: QUESTION_TYPES.LABEL, type: "Label", needSelections: false, helpText: "Use this to display static information, such as instructions or a title, without asking for any input." },
  { code: QUESTION_TYPES.MATRIX, type: "Matrix", needSelections: false, helpText: "Use this to create a Matrix question where users can provide responses in a tabular format." },
];
export const SELF_SERVICE_QUE_TYPES_PART = [
  { code: QUESTION_TYPES.OPEN, type: "Open Text", needSelections: false, helpText: "Use this to create a question with a single-line text input for users to provide short answers." },
  { code: QUESTION_TYPES.NUM, type: "Numerical", needSelections: false, helpText: "Use this to create a question where users can input numerical values, such as quantities or measurements." },
  { code: QUESTION_TYPES.SELECT, type: "Option", needSelections: true, helpText: "Use this to create a question where users can select one or more options from a predefined list." },
  { code: QUESTION_TYPES.SEL_CNTRY, type: "Option Country", needSelections: false, helpText: "Use this to create a question where users can select a country from a predefined list of countries." },
  { code: QUESTION_TYPES.SEL_CTY_UW, type: "Option Country with unknown", needSelections: false, helpText: "Use this to create a question where users can select a country from a predefined list, including an option for unknown." },
  { code: QUESTION_TYPES.SEL_STATE, type: "Option State", needSelections: false, helpText: "Use this to create a question where users can select a state or region from a predefined list." },
  { code: QUESTION_TYPES.TITL_POPUP, type: "Title Popup", needSelections: false, helpText: "Use this to create a question that displays a popup with additional information or instructions." },
  { code: QUESTION_TYPES.CHEK_POPUP, type: "Check Popup", needSelections: false, helpText: "Use this to create a question that triggers a popup when a checkbox is selected." },
  { code: QUESTION_TYPES.CHECK, type: "Checkbox", needSelections: false, helpText: "Use this to create a question with a single checkbox (yes/no), allowing users to select or clear it." },
  { code: QUESTION_TYPES.FILE, type: "File Upload", needSelections: false, helpText: "Use this to create a question where users can upload files as part of their response." },
  { code: QUESTION_TYPES.MULT_CNTRY, type: "Multiple Countries", needSelections: false, helpText: "Use this to create a question where users can select multiple countries from a predefined list of countries." },
  { code: QUESTION_TYPES.MULTI_SEL, type: "Multiple Select", needSelections: true, helpText: "Use this to create a question where users can select multiple options from a predefined list." },  
];
export const STATUS_COMPLETED = "Completed";
export const STATUS_DRAFT = "Draft";
export const SELF_SERVICE_TEMPLATE_STATUS = [ STATUS_COMPLETED, STATUS_DRAFT ]

export const SELF_SERVICE_DEPENDENCY_INFO_MSG = 'Question will be visible only when there is a match in the rule defined below.';
export const SELF_SERVICE_DEPENDENCY_INFO_MSG_STATE_DD = 'This question type requires a Country Selector as its parent.';
export const SELF_SERVICE_DEPENDENCY_INFO_TITLE = 'Question Visibility'
export const SELF_SERVICE_MATRIX_INFO_MSG = 'To display the Matrix correctly, add at least one Label question (row) and one question of another type (column) that depend on this Matrix question.';

export const SELFSERVICE_FIELD_NAMES = {
  label: "label",
  tooltip: "Tooltip",
  questionsGroup: "questionsGroup",
  required: "required",
  codeQuestionDepends: "codeQuestionDepends",
  defaultPartRelatedColumns: "defaultPartRelatedColumns",
  idSelectionDependson: "idSelectionDependson",
  idSelectionsDependson: "idSelectionsDependson",
  description: "description",
  longDescription: "longDescription",
  Section: "Section",
  Question: "Question",
  Selections: "Selections",

}

export const FILE_FORMAT_PDF = "pdf";
export const FETCHING_YOUR_SURVEYS = 'Fetching your surveys...';
export const SELF_SERVICE_NO_SURVEYS_CREATED = "Welcome! You haven't created any surveys yet. Click the 'Create Survey' button to launch your first survey.";
export const SELF_SERVICE_FILTER_IN_FILTER = "Currently, there are no surveys that fit your filter criteria. Please try different filters to find what you're looking for.";
export const SELF_SERVICE_TITLE_CREATE = "Self Service - Create Survey";
export const SELF_SERVICE_TITLE_EDIT = "Self Service - Edit Survey";
export const SELF_SERVICE_TITLE_VIEW = "Self Service - Review";
export const SURVEY_DELETE_SUCCESS = "Survey deleted successfully!";
export const SURVEY_PUBLISH_SUCCESS = "Survey published successfully!";
export const SELECT_START_DATE = "Select Start-Date to see the notification dates.";
export const NO_START_DATE = "Initial notifications will not be sent for an open ended campaign.";
export const DELINQUENT_REM_HELPTEXT = "Would change the reminder to state the request is delinquent and would continue untill the campaign is closed on the same date and frequency as defined initially.";
export const CODE_SURVEY_LANGUAGE = 'survey_language';
export const CODE_HELPDOC = 'help_doc'
export const ALL = 'all';
export const MGS_COME_BACK_LATER = "Thank you for your submission! Your response will be generated shortly. Please refresh your page or return later.\nIf the response does not appear after refreshing, kindly avoid re-uploading the Excel sheet and wait a bit before refreshing again.";
export const SELFSERVICE_EMAIL_TEMPLATE_CODE = "SS-TEMPLATE";
export const LBL_TEXT_HTML = "text/html";
export const LBL_LANGUAGESELECTION = "languageSelection";
export const LBL_ROWEMAILBODY = "rowEmailBody";
export const LBL_BODYPARAGRAPH = "bodyParagraph";
export const LBL_EMAILCONTENTBODY = "emailContentBody";
export const LBL_BODY = "body";
export const LBL_SELECTION = "selection"
export const LBL_ROW = "row";
export const FILE_DELETE_ATTACHMENT= "Delete attachment";
export const DEPENDENT_QUESTION = "Dependent Question";
export const CLASSNAME_FILEINPUT = "surveyFile";
export const EMAIL_CONTENT = "Email Notification Content";
export const SAD_DISCLAIMER_MESSAGE_KEY='sad_lbl_disclaimer_message';
export const FETCHING_DATA = "Fetching data....";
export const CREATE_SURVEY_QUE = "What do you want to do?";
export const IS_CREATE_NEW = "Create a new survey from scratch";
export const IS_CREATE_REVISION = "Create a revision of an existing survey";
export const IS_CREATE_COPY = "Create a new survey by copying an existing survey";
export const VALUE_NEW = "NEW";
export const VALUE_REVISION = "REVISION";
export const VALUE_COPY = "COPY";
export const SURVEY_NAME_LBL = "Survey Name";
export const SURVEY_NAME_PLACEHOLDER = "Please enter the survey name here...";
export const SURVEY_COPY_LBL = "Select the survey which you want to copy";
export const PROTOCOL_HTTP = "http://";
export const PROTOCOL_HTTPS = "https://"
export const PROTOCOL_MAILTO = "mailto:";
export const ATTR_HREF = "href"
export const DEFAULT_PART_SECTION_TITLES = { RESPONSES: "Responses", AUTH_INFO: "Authorizer Information", SUPP_INFO: "Supplier Information", PART_INFO: "Part Information" };
export const DEFAULT_PART_SECTION_PAYLOAD = [
  { showOrder: 1, description: DEFAULT_PART_SECTION_TITLES.RESPONSES, type: "component_response", isDefault: true, isExpandable: false },
  { showOrder: 2, description: DEFAULT_PART_SECTION_TITLES.AUTH_INFO, type: "component_questions", isDefault: false, isExpandable: true },
  { showOrder: 3, description: DEFAULT_PART_SECTION_TITLES.SUPP_INFO, type: "component_supplier", isDefault: true, isExpandable: true },
  { showOrder: 4, description: DEFAULT_PART_SECTION_TITLES.PART_INFO, type: "component_part", isDefault: true, isExpandable: true },
];
export const DEFAULT_PART_SECTION_TRANSLATIONS = {
  [DEFAULT_PART_SECTION_TITLES.RESPONSES]: { zh_CN: "响应", fr_FR: "Réponses", de_DE: "Antworten", es_MX: "Respuestas", pt_PT: "Respostas" },
  [DEFAULT_PART_SECTION_TITLES.AUTH_INFO]: { zh_CN: "授权信息", fr_FR: "Informations sur l'ordonnateur", de_DE: "Autorisierungsinformationen", es_MX: "Información del autorizador", pt_PT: "Informações do Autorizador" },
  [DEFAULT_PART_SECTION_TITLES.SUPP_INFO]: { zh_CN: "供应商信息", fr_FR: "Informations sur le fournisseur", de_DE: "Lieferanteninformationen", es_MX: "Información del Proveedor", pt_PT: "Informações do Fornecedor" },
  [DEFAULT_PART_SECTION_TITLES.PART_INFO]: { zh_CN: "零件信息", fr_FR: "Informations sur les pièces", de_DE: "Teileinformationen", es_MX: "Información de piezas", pt_PT: "Informações da Peça" },
};

export const MARKET_SEGMENT = 'Makt_Seg';
export const DEERE_DEMAND = 'Der_Demd';

export const TPS_AGREEMENT_DEPENDENCY = [
  { queCode: 'TPS_SEC5_Q005', questionDependsOn: 'TPS_SEC5_Q004', selectionDependsOn: ['US', 'CA', 'MX'], childSelectionForced: "2" },
];

export const DETAILS_PAGE_TABLE_HEADERS = {
  REQ_NO: {headerName: "Request #", accessor: "id"},
  SUPPLIER: {headerName: "Supplier", accessor: "supplierName"},
  STATUS: {headerName: "Status", accessor: "status"},
  COMPANY_CONTACT: {headerName: "Company Contact", accessor: "companyContactName"},
  DEERE_CONTACT: {headerName: "Deere Contact", accessor: "deereContactName"},
  DEERE_EMAIL: {headerName: "Deere Email", accessor: "deereContactEmail"},
  SUPP_CONTACT: {headerName: "Supplier Contact", accessor: "supplierContactName"},
  SUPP_EMAIL: {headerName: "Supplier Email", accessor: "supplierContactEmail"},
  SEND_EMAIL: {headerName: "Send Email", accessor: "sendContactEmail"},
  SUPP_CONTACT_ND: {headerName: "Supplier Contact", accessor: "nonDeereSupplierContactsIds"},
  SUBMITTED_BY: {headerName: "Submitted By", accessor: "responseByName"},
  RESPONDED_ON: {headerName: "Responded On", accessor: "responseon"},
  PART_REQ: {headerName: " Parts Requested", accessor: "partsRequested"},
  PART_DEC: {headerName: " Parts Declared", accessor: "partsDeclared"},
  DELETE_ICON: {headerName: "Delete From Campaign", accessor: "assignmentid"},
  ATTACHMENTS: {headerName: "Attachments", accessor: "attachments"},
  REOPEN: {headerName: "Reopen", accessor: "reopen"},
}
export const EMAIL_NOTIFICATION_SENT = "Email has been sent";
export const SEND_EMAIL = "Send Email";
export const REOPEN_REQUEST = "Reopen Request";
export const LBL_HELP_DOC = "Help Document";
export const OPEN_CAMPAIGN_END_DATE = "9999-12-31";// Sentinel value representing the end date for open-ended campaigns.
export const LBL_SURVEYID = "surveyId";
export const LBL_ISNONDEERE = "isNonDeere";
export const LBL_ISPRIVATESURVEY = "isPrivateSurvey";
export const LBL_ISPRIVATESURVEY_RADIO = "Is this going to be a private survey?";
export const LBL_ISOPENCAMPAIGN = "isOpenEndedCampaign";
export const LBL_COMPANYNAME = "companyName";
export const LBL_FETCHHISTORY = "fetchHistoricalData";
export const LBL_ISOPENCAMPAIGN_RADIO = "Is this going to be an open ended campaign (campaign without supplier numbers) ?";
export const TOOLTIP_PLACEHOLDER = "Please enter the tooltip here...";
export const TOOLTIP_LABEL = "Tooltip";
export const TOOLTIP_TRANSLATION_LABEL = "Help Text Translations";
export const HELP_TEXT_TRANSLATION_PLACEHOLDER = "Please enter the tooltip translation here...";
export const HELP_TEXT = "Help Text";
export const NO_INFO ="No additional information available"
export const PROPS_TO_REMOVE = ["surveyId", "id", "createdBy", "createdTs", "lastUpdatedTs", "updatedBy", "updatedTs", "surveySectionId", "questionId", "selectionId"];
export const SELFSERVICE_PATH = '/selfService';
export const SELFSERVICE_LANDING_PATH = '/selfServiceLanding';
export const  NONE_PART_SECTION = 'Non Part Section';
export const  PART_SECTION = 'Part Information';
export const FETCH_SURVEY_DATA = "Fetching Survey Details. This might take a while...";
export const AGREEMENT_POSITIONS = { SURVEY_SCREEN: "SCREEN", SUBMISSION_POPUP: "POPUP", BOTH: "BOTH" };
export const DISCLAIMER_MSG_CODE = "disclaimer_msg";
export const DISCLAIMER_MSG_POSITION = 'disclaimer_position';
export const MAX_COLUMNS = 5;
export const MAX_ADDITIONAL_COLS = 2;
export const SELFSERVICE_DEFAULT_PAYLOAD = {
  description: "",
  active: false,
  code: "",
  adminRole: "",
  homeContextPath: "survey",
  nonDeereUse: true,
  sections: [],
  helpDocs: [],
  defaultColumns: [],
  language: [{ languageCd: "en_EN", text: "English" }],
  templateType: CRS_SURVEY_TEMPLATES.GENERIC,
  templateRevision: "1",
  templateStatus: STATUS_DRAFT,
  translations: [],
  surveyNotification: "",
  agreementData: [],
  agreementPosition: "",
};

export const SEND_EMAIL_FAILURE = "Failed to send email notification"
export const REOPEN_FAILURE = "Failed to reopen the request"
export const REOPEN_SUCCESS = "The request has been reopened successfully"

export const addCol1Accessor = "additionalColumn1";
export const addCol2Accessor = "additionalColumn2";
export const addCol1 = "additional_column_1";
export const addCol2 = "additional_column_2";
export const DEERE_ADDCOL1_IDX = 4;
export const DEERE_ADDCOL2_IDX = 5;
export const NONDEERE_ADDCOL1_IDX = 7;
export const NONDEERE_ADDCOL2_IDX = 8;
export const SURVEY_NAME_FIELD = "surveyNameField";
export const SURVEY_NAME_PICKER = "surveyNamePicker";
export const SAVING_DATA = "Auto-saving your data....";
export const SAVING = "Saving your data....";
export const SAVE_SUCCESS = "✅ Data Saved Successfully.";
export const SAMPLE_COUNTRIES = ["United States", "Canada", "China", "India", "Mexico", "Germany", "France", "United Kingdom", "Japan", "Brazil", "Unknown"];
export const PROVIDE_COLUMN_NAMES = "Please enter column names for all languages";